import React, { useState } from 'react';
import Modal, { MODAL_FIELD, MODAL_LABEL, MODAL_NOTE, MODAL_ERROR, modalChoice } from './Modal';
import Button from './Button';
import { proService } from '../services';

const REASONS = [
  ['no_show', 'No-show'],
  ['quality', 'Quality issue'],
  ['misrepresented', 'Not as described'],
  ['canceled', 'Cancelled on me'],
  ['other', 'Something else'],
];
const OUTCOMES = [
  ['refund', 'Full refund'],
  ['partial_refund', 'Partial refund'],
  ['redo', 'Make it right'],
  ['other', 'Not sure'],
];

/**
 * FlagBookingModal — raise a dispute on a confirmed booking (6d). Filing while
 * escrow is held freezes the payout; an admin then resolves it. Reason + desired
 * outcome + details.
 */
export default function FlagBookingModal({ isOpen, onClose, bookingId, onFlagged }) {
  const [reason, setReason] = useState('no_show');
  const [outcome, setOutcome] = useState('refund');
  const [freeText, setFreeText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const close = () => { if (!submitting) { setError(''); onClose(); } };

  const submit = async () => {
    setSubmitting(true); setError('');
    const r = await proService.flagBooking(bookingId, { reason, desiredOutcome: outcome, freeText: freeText.trim() || null });
    setSubmitting(false);
    if (r.success) { onFlagged?.(); onClose(); }
    else setError(r.error || 'Could not file the report.');
  };

  return (
    <Modal isOpen={isOpen} onClose={close} title="Report a problem" size="md">
      <div className="space-y-4">
        <div>
          <label className={MODAL_LABEL}>What happened?</label>
          <div className="grid grid-cols-2 gap-2">
            {REASONS.map(([val, label]) => (
              <button key={val} type="button" onClick={() => setReason(val)}
                aria-pressed={reason === val}
                className={modalChoice(reason === val)}>
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className={MODAL_LABEL}>What would fix it?</label>
          <div className="grid grid-cols-2 gap-2">
            {OUTCOMES.map(([val, label]) => (
              <button key={val} type="button" onClick={() => setOutcome(val)}
                aria-pressed={outcome === val}
                className={modalChoice(outcome === val)}>
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className={MODAL_LABEL}>Details</label>
          <textarea value={freeText} maxLength={1000} rows={3} onChange={(e) => setFreeText(e.target.value)}
            placeholder="Tell us what happened — the more detail, the faster we can resolve it."
            className={`${MODAL_FIELD} resize-none`} />
        </div>
        {error && <div className={MODAL_ERROR} role="alert">{error}</div>}
        <p className={MODAL_NOTE}>Filing a report puts the payout on hold until a person reviews it.</p>
        <div className="flex gap-2">
          <Button className="flex-1" onClick={submit} disabled={submitting}>{submitting ? 'Filing…' : 'File report'}</Button>
          <Button variant="secondary" onClick={close} disabled={submitting}>Cancel</Button>
        </div>
      </div>
    </Modal>
  );
}
